<div class="topDiv" [style.background-color]="backgroundColorScreen">
    <div class="agGridOuterDiv audit-trail-page">
        <div class="row topRowMargins headerStyle page-title-row"
            style="margin-right: 0; margin-left: 0; margin-top: 3%">
            <label i18n="@@spmsUserReg" class="textColour">Audit Trail</label>
            <span class="example-spacer"></span>
            <div class="language-switcher">
                <mat-form-field appearance="outline" class="language-field" subscriptSizing="dynamic">
                    <mat-label>Language</mat-label>
                    <mat-select [(ngModel)]="selectedLanguage">
                        <mat-option *ngFor="let lang of languageOptions" [value]="lang.code">
                            {{ lang.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <!-- Search & Filters -->
        <section class="panel filters-panel">
            <div class="filters-body">
                <div class="filters-grid">
                    <div class="filter-field">
                        <mat-form-field appearance="outline" class="compact-field" subscriptSizing="dynamic">
                            <mat-label>From Date</mat-label>
                            <input matInput [(ngModel)]="filters.fromDate" [owlDateTime]="fromPicker"
                                [owlDateTimeTrigger]="fromPicker" placeholder="DD-MMM-YYYY" readonly />
                            <em matSuffix class="far fa-calendar-alt calendar-suffix"
                                [owlDateTimeTrigger]="fromPicker"></em>
                            <owl-date-time #fromPicker [pickerType]="'calendar'" [pickerMode]="'popup'"
                                panelClass="audit-trail-dt-popup"></owl-date-time>
                        </mat-form-field>
                    </div>

                    <div class="filter-field">
                        <mat-form-field appearance="outline" class="compact-field" subscriptSizing="dynamic">
                            <mat-label>To Date</mat-label>
                            <input matInput [(ngModel)]="filters.toDate" [owlDateTime]="toPicker"
                                [owlDateTimeTrigger]="toPicker" placeholder="DD-MMM-YYYY" readonly />
                            <em matSuffix class="far fa-calendar-alt calendar-suffix"
                                [owlDateTimeTrigger]="toPicker"></em>
                            <owl-date-time #toPicker [pickerType]="'calendar'" [pickerMode]="'popup'"
                                panelClass="audit-trail-dt-popup"></owl-date-time>
                        </mat-form-field>
                    </div>

                    <div class="filter-field">
                        <mat-form-field appearance="outline" class="compact-field" subscriptSizing="dynamic">
                            <mat-label>Action</mat-label>
                            <mat-select [(ngModel)]="filters.action">
                                <mat-option *ngFor="let option of actionOptions" [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="filter-field">
                        <mat-form-field appearance="outline" class="compact-field" subscriptSizing="dynamic">
                            <mat-label>User</mat-label>
                            <mat-select [(ngModel)]="filters.user" (openedChange)="onUserDropdownOpened($event)"
                                (closed)="userSearch.clearSearch()">
                                <div class="user-search-container">
                                    <app-searchable-select #userSearch [items]="userOptions" displayField="userName"
                                        (filteredItemsChange)="filteredUserOptions = $event"></app-searchable-select>
                                </div>
                                <mat-option value="">All Users</mat-option>
                                <mat-option *ngFor="let user of filteredUserOptions" [value]="user.userName">
                                    {{ user.userName }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <!-- Showcase only: Module / Screen Name are visible but not applied on Search yet. -->
                    <div class="filter-field">
                        <mat-form-field appearance="outline" class="compact-field" subscriptSizing="dynamic">
                            <mat-label>Module</mat-label>
                            <mat-select [(ngModel)]="filters.moduleName">
                                <mat-option *ngFor="let option of moduleOptions" [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="filter-field">
                        <mat-form-field appearance="outline" class="compact-field" subscriptSizing="dynamic">
                            <mat-label>Screen Name</mat-label>
                            <mat-select [(ngModel)]="filters.screenName">
                                <mat-option *ngFor="let option of screenOptions" [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <!-- <div class="filter-field">
            <mat-form-field appearance="outline" class="compact-field" subscriptSizing="dynamic">
              <mat-label>Class Name</mat-label>
              <mat-select [(ngModel)]="filters.affectedClassName">
                <mat-option *ngFor="let option of classOptions" [value]="option.value">
                  {{ option.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div> -->

                    <!-- <div class="filter-field">
            <mat-form-field appearance="outline" class="compact-field" subscriptSizing="dynamic">
              <mat-label>Table</mat-label>
              <mat-select [(ngModel)]="filters.tableName">
                <mat-option *ngFor="let option of tableOptions" [value]="option.value">
                  {{ option.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div> -->

                    <!-- <div class="filter-field">
            <mat-form-field appearance="outline" class="compact-field" subscriptSizing="dynamic">
              <mat-label>Record Name</mat-label>
              <input
                matInput
                [(ngModel)]="filters.recordName"
                placeholder="Enter Record Name"
              />
            </mat-form-field>
          </div>

          <div class="filter-field">
            <mat-form-field appearance="outline" class="compact-field" subscriptSizing="dynamic">
              <mat-label>Record ID</mat-label>
              <input
                matInput
                [(ngModel)]="filters.recordId"
                placeholder="Enter Record ID"
              />
            </mat-form-field>
          </div> -->

                    <div class="filter-actions">
                        <app-common-button label="Search" title="Search" icon="fas fa-search" [buttonId]="1111"
                            [critical]="false" width="110px" height="30px" fontSize="12px" padding="0 14px"
                            (clicked)="onSearch()" style="margin-left: 6px; margin-right: 6px">
                        </app-common-button>

                        <app-common-button label="Reset" title="Reset" icon="fas fa-sync-alt" [buttonId]="1111"
                            [critical]="false" variant="cancel" width="110px" height="30px" fontSize="12px"
                            padding="0 14px" (clicked)="onReset()" style="margin-left: 6px; margin-right: 6px">
                        </app-common-button>
                        <!-- Save Filter disabled (no localStorage persistence needed)
            <button
              type="button"
              class="btn btn-save-filter"
              [style.border-color]="buttonColor"
              [style.color]="buttonColor"
              (click)="onSaveFilter()"
            >
              <mat-icon>filter_list</mat-icon>
              SAVE FILTER
            </button>
            -->
                    </div>
                </div>
            </div>
        </section>

        <!-- Audit Events -->
        <section class="panel events-panel">
            <div class="panel-header events-header">
                <h2 class="section-title">Audit Events ({{ eventCount }})</h2>
                <div class="toolbar-actions">
                    <app-common-button label="EXPORT TO EXCEL" title="Export to Excel" icon="fas fa-file-excel"
                        [buttonId]="1111" [critical]="false" variant="cancel"
                        buttonClass="audit-toolbar-btn audit-excel-btn" width="160px" height="34px" fontSize="12px"
                        padding="0 12px" (clicked)="onExportExcel()" style="margin-left: 6px; margin-right: 6px">
                    </app-common-button>

                    <app-common-button label="EXPORT TO PDF" title="Export to PDF" icon="fas fa-file-pdf"
                        [buttonId]="1111" [critical]="false" variant="cancel"
                        buttonClass="audit-toolbar-btn audit-pdf-btn" width="145px" height="34px" fontSize="12px"
                        padding="0 12px" (clicked)="onExportPdf()" style="margin-left: 6px; margin-right: 6px">
                    </app-common-button>

                    <app-common-button label="COLUMNS" title="Columns" icon="fas fa-columns" [buttonId]="1111"
                        [critical]="false" variant="cancel" buttonClass="audit-toolbar-btn audit-columns-btn"
                        width="120px" height="34px" fontSize="12px" padding="0 12px" (clicked)="openColumnsDialog()"
                        style="margin-left: 6px; margin-right: 6px">
                    </app-common-button>
                </div>
            </div>

            <div class="grid-wrap">
                <ag-grid-angular class="ag-theme-balham audit-grid" style="width: 100%; height: 55vh;"
                    [columnDefs]="columnDefs" [rowData]="filteredEvents" [defaultColDef]="defaultColDef"
                    [gridOptions]="gridOptions" [pagination]="true" [paginationPageSize]="pageSize"
                    [paginationPageSizeSelector]="pageSizeOptions" [animateRows]="true" [headerHeight]="35"
                    [enableBrowserTooltips]="true" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
                    (paginationChanged)="onPaginationChanged()">
                </ag-grid-angular>
            </div>

            <!-- Custom pager replaced by AG Grid built-in pagination (same as HA Request)
      <div class="grid-footer">
        ...
      </div>
      -->
        </section>

        <!-- Event Details -->
        <section class="panel details-panel" *ngIf="selectedEvent as event">
            <div class="panel-header details-header" (click)="toggleDetails()">
                <h2 class="section-title">Event Details (Audit ID: {{ event.auditId }})</h2>
                <mat-icon class="collapse-icon" [style.color]="buttonColor">
                    {{ detailsExpanded ? 'expand_less' : 'expand_more' }}
                </mat-icon>
            </div>

            <div class="details-body" *ngIf="detailsExpanded">
                <div class="details-grid">
                    <div class="details-col">
                        <div class="detail-row">
                            <span class="detail-label">Audit ID</span>
                            <span class="detail-sep">:</span>
                            <span class="detail-value">{{ event.auditId }}</span>
                        </div>
                        <div class="detail-row">
                            <span class="detail-label">Timestamp</span>
                            <span class="detail-sep">:</span>
                            <span class="detail-value">{{ event.timestamp }}</span>
                        </div>
                        <div class="detail-row">
                            <span class="detail-label">User</span>
                            <span class="detail-sep">:</span>
                            <span class="detail-value">{{ event.user }}</span>
                        </div>
                        <div class="detail-row">
                            <span class="detail-label">Action</span>
                            <span class="detail-sep">:</span>
                            <span class="detail-value">
                                <span [ngClass]="getActionBadgeClass(event.action)">
                                    {{ formatActionLabel(event.action) }}
                                </span>
                            </span>
                        </div>
                        <div class="detail-row">
                            <span class="detail-label">Module</span>
                            <span class="detail-sep">:</span>
                            <span class="detail-value">{{ event.moduleName || '-' }}</span>
                        </div>
                        <div class="detail-row">
                            <span class="detail-label">Screen Name</span>
                            <span class="detail-sep">:</span>
                            <span class="detail-value">{{ event.screenName || '-' }}</span>
                        </div>
                        <div class="detail-row">
                            <span class="detail-label">Reference Screen</span>
                            <span class="detail-sep">:</span>
                            <span class="detail-value">{{ event.referenceScreen || '-' }}</span>
                        </div>
                        <div class="detail-row">
                            <span class="detail-label">Class Name</span>
                            <span class="detail-sep">:</span>
                            <span class="detail-value">{{ event.affectedClassName || '-' }}</span>
                        </div>
                    </div>

                    <div class="details-col">
                        <div class="detail-row">
                            <span class="detail-label">Table</span>
                            <span class="detail-sep">:</span>
                            <span class="detail-value">{{ event.tableName || '-' }}</span>
                        </div>
                        <div class="detail-row">
                            <span class="detail-label">Record ID</span>
                            <span class="detail-sep">:</span>
                            <span class="detail-value">{{ event.recordId || '-' }}</span>
                        </div>
                        <div class="detail-row">
                            <span class="detail-label">Record Name</span>
                            <span class="detail-sep">:</span>
                            <span class="detail-value">{{ event.recordName || '-' }}</span>
                        </div>
                        <div class="detail-row">
                            <span class="detail-label">Changed Fields</span>
                            <span class="detail-sep">:</span>
                            <span class="detail-value">{{ event.changedFields }}</span>
                        </div>
                    </div>
                </div>

                <div class="field-changes">
                    <h3 class="section-title">Field Level Changes ({{ fieldChangeCount }})</h3>
                    <div class="field-changes-table-wrap">
                        <table class="field-changes-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Database Column</th>
                                    <th>Screen Label</th>
                                    <th>Previous Value</th>
                                    <th>New Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let change of event.fieldChanges; let i = index">
                                    <td>{{ i + 1 }}</td>
                                    <td class="field-name-cell">{{ change.fieldName }}</td>
                                    <td>{{ change.screenLabel }}</td>
                                    <td class="previous-value"
                                        [class.null-value]="isNullDisplayValue(change.previousValue)">
                                        {{ change.previousValue }}
                                    </td>
                                    <td class="new-value" [class.null-value]="isNullDisplayValue(change.newValue)">
                                        {{ change.newValue }}
                                    </td>
                                </tr>
                                <tr *ngIf="!event.fieldChanges.length">
                                    <td colspan="5" class="empty-changes">No field level changes for this event.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>